import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'

import { JobsDashboardPage } from '../components'
import { JobsReportPage } from '../components/report'
import { ReportDetailedPage } from '../components/report-detailed'

export const JobsRouter = () => {
  return (
    <Routes>
      <Route index element={<JobsDashboardPage />} />
      <Route path="historic" element={<JobsReportPage />} />
      <Route path="historic/:executionId" element={<ReportDetailedPage />} />
    </Routes>
  )
}
